import React from 'react';
import PropTypes from 'prop-types';

import Loader from '../controls/loader';

const containerStyles = {
  textAlign: 'center',
  margin: 40,
  fontSize: 14,
  clear: 'both',
  display: 'block',
};

const pStyles = {
  textAlign: 'center',
};

const buttonStyles = {
  width: 200,
  margin: '10px auto',
};

export default function SearchControls(props) {
  const {
    results,
    totalResults,
    loadingSearch,
    settings,
    hasSearched,
    getMoreResults,
    hasMore,
  } = props;

  const {
    showMoreResults,
    showMoreResultsText,
  } = settings;

  const resultsLength = totalResults || results.length;

  let content = '';
  if (loadingSearch) {
    content = (
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '20%' }}>
        <Loader message="Please wait. Loading search results..." />
      </div>
    );
  } else if (hasMore && hasSearched && showMoreResults) {
    content = (
      <button
        type="button"
        className="snapgadget-btn snapgadget-load-more-btn"
        style={buttonStyles}
        onClick={() => {getMoreResults();}}
      >
        {showMoreResultsText || 'More Results'}
      </button>
    );
  } else if (resultsLength > 0 && hasSearched && showMoreResults) {
    content = (
      <p style={pStyles}>No More Results</p>
    );
  } else if (resultsLength === 0 && hasSearched && showMoreResults) {
    content = (
      <p style={pStyles}>No Results</p>
    );
  }

  return (
    <div style={containerStyles}>
      {content}
    </div>
  );
}

SearchControls.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape({

  })).isRequired,
  totalResults: PropTypes.number,
  loadingSearch: PropTypes.bool,
  settings: PropTypes.shape({
    showMoreResults: PropTypes.bool,
    showMoreResultsText: PropTypes.string,
  }).isRequired,
  hasSearched: PropTypes.bool,
  getMoreResults: PropTypes.func.isRequired,
  hasMore: PropTypes.bool,
};

SearchControls.defaultProps = {
  totalResults: null,
  loadingSearch: false,
  hasMore: false,
  hasSearched: false,
};
